import moment, { Moment } from 'moment';

export const toMomentDate = (date: Date | undefined): Moment | undefined => {
	if (!date) return undefined;
	return moment(date);
};
